globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};

appCustomerSpace.Controllers.Settings.EmailSignatureBuilderController = (function (superClass) {
  utils.extend(EmailSignatureBuilderController, superClass);

  function EmailSignatureBuilderController() {
    return EmailSignatureBuilderController.__super__.constructor.apply(this, arguments);
  }

  $.extend(EmailSignatureBuilderController.prototype, {
    init: function () {
      var controller = this;

      controller._adjustMobileSignature();

      return EmailSignatureBuilderController.__super__.init.apply(this, arguments);
    },
    initClipboard: function () {
      var controller = this;

      controller.$buttonClipboard = $('.clipboard-signature');
      controller.$buttonClipboard.on('click', function () { controller._copy(); });
      
      controller.$buttonClipboardHtml = $('.clipboard-signature-html');
      controller.$buttonClipboardHtml.on('click', function () { controller._copyHtmlCode(); });
    },
    _copy: function () {
      var controller = this;
      var htmlContent = $('.signature > table')[0].outerHTML;
      var blob = new Blob([htmlContent], { type: "text/html" });
      var clipboardItem = new ClipboardItem({ "text/html": blob });

      navigator.clipboard.write([clipboardItem]).then(() => {
        controller._copied(controller.$buttonClipboard);
      }).catch(err => {
        console.error("Erreur lors de la copie : ", err);
      });
    },
    _copyHtmlCode: function () {
      var controller = this;
      var signature = $('.signature > table')[0].outerHTML;
      signature = signature.replace(/\n/g, '').replace(/\s{2,}/g, ' ').replace(/>\s+</g, '><');

      navigator.clipboard.writeText(signature).then(() => {
        controller._copied(controller.$buttonClipboardHtml);
      }).catch(err => {
        console.error('Erreur lors de la copie : ', err);
      });
    },
    _copied: function ($button) {
      var controller = this;

      if ($button.data('event-path') != "") {
        $.ajax({ url: controller.$buttonClipboard.data('event-path'), method: 'GET' });
      }

      var buttonClipboardContent = $button[0].innerHTML;
      $button.html('<i class="icon-check position-left"></i> Copié');

      setTimeout(function () {
        $button.html(buttonClipboardContent);
      }, 2000);
    },
    _adjustMobileSignature() {
      var $signature = $('.signature'),
        $panel = $signature.closest('.col-lg-9'),
        containerWidth = $panel.width();
      let tableWidth = $signature.width();
      let scale = containerWidth / tableWidth;

      if (scale > 1) scale = 1;
      if (scale < 0.5) scale = 0.5;

      $('.email-window').css('width', containerWidth);

      $signature.css({
        'transform': 'scale(' + scale + ')',
        'transform-origin': 'top left',
        'display': 'inline-block'
      });
    }
  });

  return EmailSignatureBuilderController;

})(appCustomerSpace.Controllers.Settings.MainController);
